import { render, staticRenderFns } from "./GamePuzzle.vue?vue&type=template&id=78d46802&scoped=true"
import script from "./GamePuzzle.vue?vue&type=script&lang=js"
export * from "./GamePuzzle.vue?vue&type=script&lang=js"
import style0 from "./GamePuzzle.vue?vue&type=style&index=0&id=78d46802&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d46802",
  null
  
)

export default component.exports